import { CSSProperties, useCallback, useRef } from 'react';

function transformEmpty(text: string) {
  return text === ' \n ' ? '' : text;
}

export function EditableText({
  text,
  style,
  onFocus,
  onChange,
  onBlur,
  onCustomKeyDown,
}: {
  text?: string;
  style?: CSSProperties;
  onFocus?: () => void;
  onChange?: (text: string) => void;
  onBlur?: (text: string) => void;
  onCustomKeyDown?: (e: React.KeyboardEvent<HTMLDivElement>) => void;
}) {
  const containerRef = useRef<HTMLDivElement>(null);

  const isUnderCompositionRef = useRef(false);

  const handleFocus = useCallback(() => {
    onFocus?.();
  }, []);

  const handleBlur = useCallback((e: React.FocusEvent<HTMLDivElement>) => {
    let text = e.currentTarget.innerText;
    text = transformEmpty(text);
    text = text.trim();
    onBlur?.(text);
  }, []);

  const handleChange = useCallback((e: React.ChangeEvent<HTMLDivElement>) => {
    let text = e.currentTarget.innerText;
    text = transformEmpty(text);
    text = text.trim();
    onChange?.(text);
  }, []);

  const handleKeyDown = useCallback((e: React.KeyboardEvent<HTMLDivElement>) => {
    if (!isUnderCompositionRef.current) {
      if (onCustomKeyDown) {
        onCustomKeyDown(e);
        return;
      }

      if (e.key === 'Enter') {
        e.preventDefault();
        e.currentTarget.blur();
      }
    }
  }, []);

  return (
    <div
      ref={containerRef}
      style={style}
      contentEditable={true}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onInput={handleChange}
      onKeyDown={handleKeyDown}
      suppressContentEditableWarning
      onCompositionStart={(e) => {
        isUnderCompositionRef.current = true;
      }}
      onCompositionEnd={(e) => {
        isUnderCompositionRef.current = false;
      }}
    >
      {text}
    </div>
  );
}
